module.exports = __webpack_public_path__ + "img/green_wave-03.ea192d00.png";